 <template>
  <div>
    <action-sidebar :title="title" :value="true" @close-modal="closeModal">
      <template-form
        :role-id="id"
        :code-project="codeProject"
        :project-id="projectId"
        :code-template="templateCode"
      />
    </action-sidebar>
  </div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import templateForm from '@/components/template/template-form';
import helper from '@/shared/helper';

const { getLocalData } = helper;

function created() {
  this.idProject = this.projectId || getLocalData('project-id');
  this.templateCode = this.codeTemplate || getLocalData('code-template');
}

function closeModal() {
  this.goTo('page-template', {
    params: { projectId: this.idProject, codeProject: this.codeProject },
  });
}

function title() {
  return `Nueva Compañia <- ${this.name}`;
}

function data() {
  return {
    idProject: 0,
    templateCode: 0,
  };
}

export default {
  name: 'page-template-new',
  components: {
    actionSidebar,
    templateForm,
  },
  computed: {
    title,
  },
  created,
  data,
  methods: {
    closeModal,
  },
  props: {
    codeProject: {
      type: String,
      required: true,
    },
    name: {
      type: String,
    },
    id: {
      type: [Number, String],
    },
    projectId: {
      type: [Number, String],
    },
    codeTemplate: {
      type: [Number, String],
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/template/page-template-new.vue